import React from 'react';
import BaseList from 'components/lists/BaseList';
import { datetimeFormatter } from 'utils/formatters.js';
import { useAccessLog } from 'hooks/logs';
import TableCell from '@material-ui/core/TableCell';
import Chip from '@material-ui/core/Chip';
import Button from '@material-ui/core/Button';
import { post } from 'services/fetch';
import { emitEvent } from 'utils/events';

const STATUS_LABEL = {
  PENDING: 'Aguardando processamento',
  PROCESSING: 'Processando',
  COMPLETED: 'Concluído',
  FAILED: 'Falha',
};

function statusChip(row) {
  const s = row.status;
  const label = STATUS_LABEL[s] || s || '-';
  const style =
    s === 'FAILED'
      ? { backgroundColor: '#e44a4a', color: '#fff' }
      : s === 'PENDING'
      ? { backgroundColor: '#fd8f44', color: '#fff' }
      : s === 'COMPLETED'
      ? { backgroundColor: '#5bf293', color: '#1a1a1a' }
      : s === 'PROCESSING'
      ? { backgroundColor: '#41475a', color: '#fff' }
      : {};

  return <Chip size="small" label={label} style={style} />;
}

async function downloadResult(row) {
  try {
    const response = await post(`gestao-chips-import/download/${row._id}`, {});
    if (!response.ok) {
      emitEvent('showSnack', {
        message: 'Não foi possível baixar o arquivo',
        type: 'error',
      });
      return;
    }
    const name =
      (row.resultFile && row.resultFile.filename) ||
      'gestao-chips-resultado.xlsx';
    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = downloadUrl;
    link.setAttribute('download', name);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
    window.URL.revokeObjectURL(downloadUrl);
  } catch (e) {
    emitEvent('showSnack', {
      message: 'Erro ao baixar o arquivo',
      type: 'error',
    });
  }
}

function ListGestaoChips(props) {
  useAccessLog('Acesso à gestão de chips');
  const { match } = props;

  return (
    <BaseList
      suppressRowNavigation
      defaultQuerySort={{ date: -1 }}
      columns={[
        {
          value: row => (row.inputFile ? row.inputFile.filename : '-'),
          label: 'Arquivo',
          sort: 'inputFile.filename',
        },
        {
          value: row => row.description || '-',
          label: 'Descrição',
          sort: 'description',
        },
        {
          value: row =>
            row.date ? datetimeFormatter(row.date) : '-',
          label: 'Data da importação',
          sort: 'date',
          defaultSort: true,
          defaultSortDesc: true,
        },
        {
          value: row => (row.user ? row.user : '-'),
          label: 'Usuário',
          sort: 'user',
        },
        {
          label: 'Status',
          sort: 'status',
          component: row => (
            <TableCell key={`${row._id}-status`}>{statusChip(row)}</TableCell>
          ),
        },
        {
          label: 'Download',
          component: row => (
            <TableCell
              key={`${row._id}-dl`}
              onClick={e => e.stopPropagation()}
            >
              {row.status === 'COMPLETED' ? (
                <Button
                  size="small"
                  color="primary"
                  variant="outlined"
                  onClick={e => {
                    e.stopPropagation();
                    downloadResult(row);
                  }}
                >
                  Download
                </Button>
              ) : (
                '—'
              )}
            </TableCell>
          ),
        },
      ]}
      genericSearchFields={[
        { label: 'Nome do Arquivo', name: 'inputFile.filename' },
      ]}
      basePath="gestao-chips-import"
      title="Gestão de Chips"
      addButtonText="Nova importação"
      addUrl={`${match.path}/novo`}
    />
  );
}

export default ListGestaoChips;
